// Le descrizioni scritte prima dell'editor visuale sono testo semplice: per
// aprirle nell'editor senza perdere gli a capo diventano paragrafi HTML.
export const testoInHtml = (valore) => {
    const testo = String(valore || '');
    if (!testo.trim() || /<\/?[a-z][^>]*>/i.test(testo)) return testo;
    const sicuro = testo.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return sicuro.split(/\n{2,}/).map(parte => `<p>${parte.replace(/\n/g, '<br>')}</p>`).join('');
};

// Vero se l'HTML dell'editor non contiene testo (per i campi obbligatori).
export const htmlVuoto = (valore) => !String(valore || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
